import { render, staticRenderFns } from "./PcDetail.vue?vue&type=template&id=03bb814c&scoped=true"
import script from "./PcDetail.vue?vue&type=script&lang=js"
export * from "./PcDetail.vue?vue&type=script&lang=js"
import style0 from "./PcDetail.vue?vue&type=style&index=0&id=03bb814c&prod&scoped=true&lang=css"
import style1 from "./PcDetail.vue?vue&type=style&index=1&id=03bb814c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bb814c",
  null
  
)

export default component.exports